<template>
  <div class="user">
    <div class="photo">
      <img :src="avatar" alt="avatar" />
    </div>
    <div class="user-info">
      <a
        data-toggle="collapse"
        :aria-expanded="!isClosed"
        @click.stop="toggleMenu"
        @click.capture="clicked"
      >
        <span>
          {{ username }}
          <b class="caret"></b>
        </span>
      </a>

      <!-- <collapse-transition> -->
      <div v-show="!isClosed">
        <ul class="nav">
          <slot>
            <li>
              <a href="#" @click.prevent="logout">
                <md-icon>logout</md-icon>
                <span class="sidebar-normal">Logout</span>
              </a>
            </li>
          </slot>
        </ul>
      </div>
      <!-- </collapse-transition> -->
    </div>
  </div>
</template>
<script>
import { CollapseTransition } from "vue2-transitions";
import { AuthLogout } from "@/store/actions/auth";

export default {
  components: {
    // CollapseTransition
  },
  props: {
    title: {
      type: String,
      default: ""
    },
    avatar: {
      type: String,
      default: "/img/faces/user_avatar.png"
    }
  },
  data() {
    return {
      isClosed: true
    };
  },
  methods: {
    clicked: function(e) {
      e.preventDefault();
    },
    toggleMenu: function() {
      this.isClosed = !this.isClosed;
    },
    logout: function() {
      this.$store.dispatch(AuthLogout).then(resp => {
        this.$router.push("/login");
        this.$notify({
          timeout: 2500,
          message: "You've been logged out!",
          icon: "logout",
          horizontalAlign: "center",
          verticalAlign: "top",
          type: "warning"
        });
      });
    }
  },
  computed: {
    username() {
      return this.$store.state.auth.user?.first_name ?? "Anon!";
    }
  }
};
</script>
<style>
.collapsed {
  transition: opacity 1s;
}
</style>
